import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import AvailableJobs from './AvailableJobs';
import messages from '../../../locale/messages';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.availableJobs);

    const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    if (!isAdminAuthenticated) {
        return { redirect: '/login' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <AvailableJobs />
            </AdminLayout>
        ),
    };
}

export default action;
